import EmptyModal from "~/components/EmptyModal/EmptyModal";
import styles from "./ConfirmActionModal.module.css";
import Button from "~/components/Button/Button";
import EmptyState from "~/components/EmptyState/EmptyState";
import FailedIcon from "~/icons/FailedIcon";

type ChangeOrderModalProps = {
  visible: boolean;
  onClose: () => void;
  onConfirm: () => void;
  icon?: () => JSX.Element;
  title?: string;
  body?: string;
};

const ConfirmActionModal: React.FC<ChangeOrderModalProps> = ({
  visible,
  onClose,
  onConfirm,
  icon: Icon,
  title,
  body,
}) => {
  return (
    <EmptyModal visible={visible} onClose={onClose}>
      <div className={styles.content}>
        <EmptyState
          icon={Icon ?? FailedIcon}
          title={title ?? "This action will reset your order"}
          description={body ?? "Are you sure you want to proceed?"}
        />
        <div className={styles.buttons}>
          <Button variant="secondary" onClick={onClose}>
            Go back
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              onConfirm();
              onClose();
            }}
          >
            Confirm
          </Button>
        </div>
      </div>
    </EmptyModal>
  );
};

export default ConfirmActionModal;
